import { runApp, IAppConfig, getSearchParams, request } from 'ice';
import localStore from 'store';
import { Button, ConfigProvider, Modal, Spin } from 'antd';
import { ExclamationCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import zhCN from 'antd/lib/locale/zh_CN';
import _ from 'lodash';
import { loginFunc } from "@/utils/auth";

const routeParams = getSearchParams();
let showMsg = true;

const appConfig: IAppConfig = {
  request: [
    {
      baseURL: '',
      headers: {},
      interceptors: {
        request: {
          onConfig: (config: any) => {
            const userinfo = localStore.get('userInfo');
            const employeeInfo = localStore.get('employeeInfo');
            const roleListStr = localStore.get('roleListStr') || '';
            // 无需token接口
            const whiteList = [
              `/api-uaa/login/password`,
              `/api-uaa/login/threeBind`,
              `/api-node/appPool/queryappindividuation`,
              `/api-node/common/loginConfig`,
              `/api-node/sysuser/getSmsCodeEn`,
              `/api-node/sysuser/retrievePassword`,
              `/api-training-user/login`,
              '/api-external/login/entUserLogin',
              '/api-external/sysEnterprise/getHomeByDomainName'
            ]
            // 无需员工信息接口
            const dianLianList = [
              `/api-node/sysuser/requireResetPassword`,
              `/api-node/university/getUniversityUserInfo`,
              `/api-node/external/role/auth/queryUserToRole`,
              `/api-node/cooApp/getAppList`,
              `/api-node/appMenuSum/queryOperateMenuList`,
              `/api-node/sysuser/querymenu`,
              `/api-node/sysuser/editHeadImg`,
            ]
            if (whiteList.includes(config.url)) {
              config.headers = {
                'x-appid-header': config.url.includes('sysuser/querymenu')  ? '2' : '7',
                'x-encryption-header': '25f5d7d10e9049328539c3eba91658a8',
              }
            } else if (dianLianList.includes(config.url)) {
              config.headers = {
                'Authorization': `${_.get(userinfo, 'token_type', 'bearer')} ${localStore.get('token')}`,
                'x-appid-header': config.url.includes('sysuser/querymenu')  ? '2' : '7',
              }
            } else if (config.url.includes('dfs.sunwoda.com')) {
              config.headers = {}
            } else {
              config.headers = {
                'Authorization': `${_.get(userinfo, 'token_type', 'bearer')} ${localStore.get('token')}`,
                'x-appid-header': (config.url.includes('sysuser/querymenu') || config.url.includes('sysuser/editHeadImg')) ? '2' : '7',
                'x-userid-header': _.get(employeeInfo, 'userId', ''),
                'x-employee-no-header': _.get(employeeInfo, 'employeeNo', ''),
                'x-username-header': encodeURIComponent(_.get(employeeInfo, 'employeeName', '')),
                'x-orgLlOneCode-header': encodeURIComponent(_.get(employeeInfo, 'orgLlOneCode', '')),
                'x-orgLlTwoCode-header': encodeURIComponent(_.get(employeeInfo, 'orgLlTwoCode', '')),
                'x-orgLlThirdCode-header': encodeURIComponent(_.get(employeeInfo, 'orgLlThirdCode', '')),
                'x-orgCode-header': encodeURIComponent(_.get(employeeInfo, 'orgCode', '')),
                'x-roles-header': encodeURIComponent(roleListStr),
                'x-encryption-header': '25f5d7d10e9049328539c3eba91658a8',
              }
            }
            return config;
          },
          onError: (error) => {
            return Promise.reject(error);
          },
        },
        response: {
          onConfig: (response) => {
            const whiteCodeList = [200, 401]
            if ( _.has(response, 'data.resp_code') && !_.includes(whiteCodeList, _.get(response, 'data.resp_code'))) {
              if (_.includes(_.get(response, 'data.resp_msg'), 'Error')) {
                Modal.warning({
                  width: '50%',
                  title: `${_.get(response, 'config.url')} ${_.get(response, 'data.resp_code')}`,
                  content: JSON.stringify(_.get(response, 'data')),
                });
              } else {
                Modal.warning({
                  title: _.get(response, 'data.resp_msg'),
                });
              }
            }
            return response;
          },
          onError: (error) => {
            if (_.get(error, 'response.status') == 401) {
              if (showMsg) {
                showMsg = false
                Modal.confirm({
                  title: '提示',
                  icon: <ExclamationCircleOutlined />,
                  content: '登录已经过期，请重新登录',
                  onOk() {
                    showMsg = true
                    localStore.clearAll()
                    window.location.href = '/login';
                  },
                  onCancel() {
                    showMsg = true
                  },
                });
              }
            } else {
              if (error.response) {
                Modal.error({
                  title: `${_.get(error, 'response.config.url')} ${_.get(error, 'response.status')} ${_.get(error, 'response.statusText')}`,
                  content: JSON.stringify(_.get(error, 'response.data')),
                })
              } else {
                if (error.message.includes('Network')) {
                  Modal.error({
                    title: '网络故障',
                    content: '请检查您的网络，或联系网络管理员',
                  })
                } else {
                  Modal.error({
                    title: error.name,
                    content: error.message,
                  })
                }
              }
            }
            return Promise.reject(error);
          },
        },
      }
    },
  ],
  app: {
    rootId: 'ice-container',
    addProvider: ({ children }) => {
      return <ConfigProvider locale={zhCN}>{children}</ConfigProvider>;
    },
    errorBoundary: true,
    ErrorBoundaryFallback: (props, context) => {
      return (
        <div style={{
          width: '100%',
          minHeight: 'calc(100vh - 116px)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <LoadingOutlined style={{ fontSize: '56px', color: '#999' }}/>
          <h1 style={{ color: '#999', marginTop: '16px', maxWidth: '80vw' }}>{_.get(props, 'error.message', '系统错误')}</h1>
          {/* <code style={{
            color: '#999',
            background: '#333',
            padding: 20,
            fontSize: '14px',
            whiteSpace: 'pre-wrap',
          }}>{_.get(props, 'error.stack', '页面渲染错误')}</code>
          <p style={{ color: '#999', margin: '12px 0 6px 0', maxWidth: '80vw' }}>{window.location.href}</p> */}
          <h3 style={{ color: '#999' }}>{_.includes(window.location.href,'examinationResult')? '题库有误,请联系管理员检查题库' : '系统错误，请反馈给开发人员'} </h3>
          <Button type="link" onClick={() => {
            window.history.back()
            setTimeout(() => {window.location.reload()}, 200)
          }}>返回上一页</Button>
        </div>
      )
    },
    onErrorBoundaryHandler: (error: Error, componentStack: string) => {},
    getInitialData: async () => {
      if (routeParams.userInfo) {
        let userInfo = JSON.parse(decodeURIComponent(routeParams.userInfo as string))
        let json = { ...userInfo, username: routeParams.username }
        localStore.set('userInfo', json)
      }
      if (routeParams.token) {
        localStore.set('token', routeParams.token)
        await loginFunc(() => {})
      }
      return {
        auth: {
          lecturer: false,
        },
      };
    },
  },
  router: {
    type: 'browser',
    basename: '/',
    fallback:
    <div style={{
      width: '100%',
      height: 'calc(100vh - 116px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <Spin size="large"/>
      <h1 style={{ color: '#999', marginTop: '16px' }}>页面加载中</h1>
    </div>
  },
};

runApp(appConfig);
